import "./CurrentStripeCardComponent.scss";
import {IComponentOptions} from "angular";
import {StripeCardSummary} from "../../types/TfStripeTypes";

export const CurrentStripeCard = "tfCurrentStripeCard";

export function currentStripeCard(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/current-card-summary/CurrentStripeCardComponent.html`,
        bindings: {
            card: "<"
        },
        controllerAs: "ctrl",
        controller: CurrentStripCardComponentController
    };
}

export class CurrentStripCardComponentController {
    public card: StripeCardSummary;
}
